import React from 'react';

type Props = {
  title?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  onClick?: () => void;
  errorCount?: number;
  onErrorClick?: () => void;
};

const RTIFillingSection: React.FC<Props> = ({
  title = '',
  description = '',
  startDate = '',
  endDate = '',
  onClick,
  errorCount = 0,
  onErrorClick,
}: Props) => (
  <div
    className="h-[165px] border border-[#00CA98] rounded-[8px] bg-[#072627] py-[20px] px-[16px] cursor-pointer relative"
    onClick={onClick}
  >
    <div className="flex items-start justify-between">
      <div className="text-[16px] font-[600] text-white mt-[8px] mb-[50px]">
        {title}
      </div>
      {errorCount > 0 && (
        <div
          className="flex flex-col items-center bg-[#FEF2F2] border border-[#FCA5A5] rounded-[8px] px-[10px] py-[4px] cursor-pointer hover:bg-[#FEE2E2] transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onErrorClick?.();
          }}
        >
          <div className="text-[14px] font-bold text-[#DC2626]">
            {errorCount}
          </div>
          <div className="text-[10px] font-medium text-[#DC2626]">
            Errors
          </div>
        </div>
      )}
    </div>
    <div>
      <div className="text-[14px] text-white mb-[8px]">{description}</div>
      <div className="text-[14px] text-white">
        {startDate || ''}
        {startDate && endDate ? ' \u2192 ' : ''}
        {endDate || ''}
      </div>
    </div>
  </div>
);

export default RTIFillingSection;
